<div class="container">
    <form [formGroup]="filtersForm" novalidate>
        <div class="search-div">
            <mat-icon class="search-icon" [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }">search</mat-icon>
            <mat-form-field class="global-search-term">
                <input matInput formControlName="searchControlName" [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }" (input)="onSearch()" />
                <fa-icon
                    [icon]="resetFilterIcon"
                    class="icon-reset-filter"
                    [ngClass]="{ 'active-filter': !!filtersForm.controls['searchControlName'].value }"
                    matSuffix
                    matTooltip="Réinitialiser la recherche"
                    (click)="resetFilter()"></fa-icon>
            </mat-form-field>
        </div>
    </form>

    <div class="users">
        @for (user of filteredUsers; track user.login) {
            <app-tchat-user-identity
                class="user"
                [ngClass]="{ selected: selectedUser === user }"
                [notifications]="user.notifications"
                [user]="user"
                [isLiveTchat]="true"
                (click)="onSelected(user)"></app-tchat-user-identity>
        }
    </div>
</div>
